import PropTypes from 'prop-types'
import styled from 'styled-components'
import IconLink from 'components/Shared/IconLink/Index'

const StyledIconLink = styled(IconLink)`
  padding: 2px 5px 2px 2px;
`

const ClearIndicator = (props) => {
  const { innerProps } = props

  return (
    <StyledIconLink
      {...innerProps}
      iconName='icon-clear-search'
    />
  )
}

ClearIndicator.propTypes = {
  innerProps: PropTypes.object,
}

export default ClearIndicator
